// extracted by mini-css-extract-plugin
module.exports = {"disclaimerContainer":"styles_disclaimerContainer__upHAg","disclaimerInner":"styles_disclaimerInner__Ehv_1"};